import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class PaginatorIntlService extends MatPaginatorIntl {
  //* Variables
  public override itemsPerPageLabel = 'Filas por página';
  public override nextPageLabel = 'Página siguiente';
  public override previousPageLabel = 'Página anterior';
  public override firstPageLabel = 'Primera página';
  public override lastPageLabel = 'Última página';

  //* Public Methods
  public override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const start = page * pageSize;
    if (length === 0 || pageSize === 0 || start >= length) return `0 de ${length}`;
    const end = Math.min(start + pageSize, length);
    return `${start + 1} – ${end} de ${length}`;
  };
}
